import * as $ from "jquery";

const MOBILE_LINE_HEIGHT = 24;
const DESKTOP_LINE_HEIGHT = 28;
const OFFSET = 1;
const MAX_LINE_CLAMP = 4;

// line-clamp to margin-bottom pair
const MARGIN_BOTTOMS = {
  4: '34px',
  3: '26px',
  2: '18px',
  1: '10px'
};

export default class DynamicLineClamp {
  componentRoot: JQuery<HTMLElement>;
  params: any;
  submitSearch: JQuery<HTMLElement>;
  searchForm: JQuery<HTMLElement>;
  $window?: JQuery<Window & typeof globalThis>;

  constructor(componentRoot: HTMLElement, params: any) {
    this.componentRoot = $(componentRoot);
    this.params = params;

    this.submitSearch = $('#search-submit', this.componentRoot);
    this.searchForm = $('#search-form', this.componentRoot);
    this.init();
  }

  init() {
    this.$window = $(window);
    this.modifyLineClamp();

    this.submitSearch.on('click', this.modifyLineClamp);
    this.searchForm.on('submit', this.modifyLineClamp);
  }

  modifyLineClamp() {
    const lineHeight = /Mobi|Android/i.test(navigator.userAgent) ? MOBILE_LINE_HEIGHT : DESKTOP_LINE_HEIGHT;

    $(".component--template-card__info").each((_, infoElement) => {
      const titleElement = $(".component--template-card__title", infoElement);
      const descriptionElement = $(".component--template-card__description", infoElement);
      const lineCount = titleElement.height() / lineHeight;
      const lineClamp = MAX_LINE_CLAMP - lineCount + OFFSET;
      const marginBottom = MARGIN_BOTTOMS[lineClamp];
      descriptionElement.css("-webkit-line-clamp", lineClamp.toString());
      titleElement.css("margin-bottom", marginBottom);
    });
  }
}
